import PropTypes from 'prop-types';
import CustomDropdownField from './custom-dropdown-field';
import ClearCustomFieldButton from './clear-custom-field-button';
import { TextInput } from '@evertrue/et-components';

const CustomStringField = ({ value, customField = {}, handleChange = () => {}, handleTouched = () => {} }) => {
  if (customField.uiControlType === 'FREEFORM') {
    return (
      <TextInput
        value={value}
        onChange={(val) => handleChange(customField.id, val)}
        maxLength={500}
        onBlur={handleTouched}
      />
    );
  } else {
    return (
      <div className="interaction-custom-fields-form--input">
        <CustomDropdownField
          value={value}
          customField={customField}
          handleChange={handleChange}
          handleTouched={handleTouched}
        />
        {value ? <ClearCustomFieldButton onClick={() => handleChange(customField?.id, null)} /> : undefined}
      </div>
    );
  }
};

CustomStringField.propTypes = {
  value: PropTypes.any,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool,
    uiControlType: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleTouched: PropTypes.func,
};

export default CustomStringField;
